import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { SpaceBetween } from '@cloudscape-design/components';
import UploadSection from './UploadSection.jsx';
import ProcessingSection from './ProcessingSection.jsx';
import RecentJobs from './RecentJobs.jsx';
import ThemeToggle from './ThemeToggle.jsx';
import './bliss.css';

export default function Bliss() {
  const navigate = useNavigate();
  const [currentJobRunId, setCurrentJobRunId] = useState(null);
  const [currentJobIdentifier, setCurrentJobIdentifier] = useState(null);
  const [refreshJobs, setRefreshJobs] = useState(0);

  const handleJobStarted = (jobRunId, jobIdentifier) => {
    setCurrentJobRunId(jobRunId);
    setCurrentJobIdentifier(jobIdentifier);
    setRefreshJobs(prev => prev + 1);
  };

  const handleJobCompleted = () => {
    setRefreshJobs(prev => prev + 1);
  };

  return (
    <div className="bliss-page">
      <ThemeToggle />
      <Link to="/" className="bliss-back-link" aria-label="Back to SmartBiz Toolkit">
        ← Back to SmartBiz Toolkit
      </Link>
      <div className="bliss-container">
        {/* Hero banner */}
        <div className="bliss-hero">
          <div className="bliss-hero-left">
            <div className="bliss-hero-icon">📊</div>
            <div className="bliss-hero-text">
              <h1 className="bliss-hero-title">BLISS</h1>
              <p className="bliss-hero-subtitle">BD Lead Intelligence & Sales System — AI-powered lead enrichment</p>
              <div className="bliss-hero-status">
                <span className="bliss-status-dot"></span>
                <span>Ready to process (up to 200 leads)</span>
                <span className="bliss-status-sep">|</span>
                <span>15-step enrichment pipeline</span>
                <span className="bliss-status-sep">|</span>
                <a
                  href="/lead-enrichment/scoring_graph_visual.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bliss-scoring-link"
                >
                  📊 How scoring works
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bliss-content">
          <SpaceBetween size="l">
            <UploadSection onJobStarted={handleJobStarted} />

            {currentJobRunId && (
              <ProcessingSection
                jobRunId={currentJobRunId}
                jobIdentifier={currentJobIdentifier}
                onJobCompleted={handleJobCompleted}
              />
            )}

            <RecentJobs refreshTrigger={refreshJobs} />
          </SpaceBetween>
        </div>
      </div>
    </div>
  );
}
